module.exports = __webpack_public_path__ + "static/img/promoter_english.3f004bd6.gif";